import React, { FormEvent, useState } from 'react';
import { submitSubscription } from '../../services/subscriptionService';

interface NewsletterProps {
  title?: string;
  subtitle?: string;
}

const Newsletter: React.FC<NewsletterProps> = ({
  title = 'Stay Updated',
  subtitle = 'Subscribe to our newsletter for the latest AI education insights, tutorials, and resources delivered to your inbox.'
}) => {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [statusMessage, setStatusMessage] = useState('');

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    
    if (!email.trim()) {
      return;
    }

    setIsSubmitting(true);
    setSubmitStatus('idle');
    setStatusMessage('');

    try {
      await submitSubscription(email.trim());
      setSubmitStatus('success');
      setStatusMessage('Thank you for subscribing!');
      setEmail(''); // Clear the input on success
    } catch (error) {
      console.error('Failed to submit subscription', error);
      setSubmitStatus('error');
      setStatusMessage('Something went wrong. Please try again later.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="newsletter-section" style={{padding: '80px 0', background: 'linear-gradient(135deg, #FF6B35 0%, #F7931E 100%)'}}>
      <div className="container">
        <div className="row">
          <div className="col-lg-8 mx-auto text-center">
            <h2 className="text-white mb-4" style={{fontSize: '2.5rem', fontWeight: 700}}>{title}</h2>
            <p className="text-white mb-5" style={{fontSize: '1.2rem', opacity: 0.9}}>{subtitle}</p>
            <form className="newsletter-form" onSubmit={handleSubmit}>
              <div className="input-group">
                <input 
                  type="email" 
                  className="form-control" 
                  placeholder="Enter your email address" 
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  disabled={isSubmitting}
                />
                <button 
                  type="submit"
                  disabled={isSubmitting}
                  style={{
                    background: '#FF6B35',
                    color: '#fff',
                    border: 'none',
                    padding: '16px 32px',
                    fontWeight: 600,
                    borderRadius: 0,
                    transition: 'background 0.3s ease',
                    cursor: isSubmitting ? 'not-allowed' : 'pointer',
                    opacity: isSubmitting ? 0.7 : 1
                  }}
                  onMouseEnter={(e) => {
                    if (!isSubmitting) {
                      e.currentTarget.style.background = '#e55a2b';
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (!isSubmitting) {
                      e.currentTarget.style.background = '#FF6B35';
                    }
                  }}
                >
                  {isSubmitting ? 'Subscribing...' : 'Subscribe'}
                </button>
              </div>
              {submitStatus !== 'idle' && (
                <div 
                  className={`mt-3 ${submitStatus === 'success' ? 'text-white' : 'text-white'}`}
                  style={{
                    fontSize: '1rem',
                    fontWeight: submitStatus === 'success' ? 600 : 400,
                    color: submitStatus === 'success' ? '#ffffff' : '#ffebee'
                  }}
                >
                  {statusMessage}
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Newsletter;

